/**
 * Analytics utility for Google Analytics tracking.
 * Provides a safe wrapper around the gtag function.
 */

const GA_TRACKING_ID = 'G-53NR18LH4P';

/**
 * Sends a custom event to Google Analytics.
 * @param {string} eventName - Name of the event (e.g., 'hero_game_click').
 * @param {Object} params - Additional parameters for the event.
 */
export const trackEvent = (eventName, params = {}) => {
    if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, params);

        // Log to console in development
        if (process.env.NODE_ENV !== 'production') {
            // console.log(`%c[Analytics] Event: ${eventName}`, 'color: #FAAE1C; font-weight: bold;', params);
        }
    } else {
        if (process.env.NODE_ENV !== 'production') {
            // console.warn('[Analytics] gtag is not defined. Skipping event:', eventName);
        }
    }
};

/**
 * Sends a page view event to Google Analytics.
 * @param {string} pagePath - The URL path of the page (e.g., '/home').
 * @param {string} pageTitle - The title of the page.
 */
export const trackPageView = (pagePath, pageTitle = document.title) => {
    if (typeof window.gtag === 'function') {
        window.gtag('config', GA_TRACKING_ID, {
            page_path: pagePath,
            page_title: pageTitle,
        });

        // Log to console in development
        if (process.env.NODE_ENV !== 'production') {
            // console.log(`%c[Analytics] PageView: ${pagePath}`, 'color: #FAAE1C; font-weight: bold;', { pageTitle });
        }
    } else {
        if (process.env.NODE_ENV !== 'production') {
            // console.warn('[Analytics] gtag is not defined. Skipping PageView:', pagePath);
        }
    }
};
